/**
 * SportDataGatewayQueryInfo defines query and callbacks for sports data client.
 * @class SportDataGatewayQueryInfo
 */
export class SportDataGatewayQueryInfo {
    /**
     * Creates an instance of SportDataGatewayQueryInfo
     * @param {string} Query OData query for sports data
     * @param {OnNext} onMessageHandler Callback to proceed with updates
     * @example
     * let query = new SportDataGatewayQueryInfo("events?$top=400&$filter=sportId eq '1'", this.messageHandler);
     */
    /* istanbul ignore next */
    constructor(query, onMessageHandler) {
        this.query = query;
        this.onMessageHandler = onMessageHandler;
        this.locale = "";
        this.from = "";
        this.until = "";
        this.timeRange = "";
        this.includeMarkets = "";
        this.initialData = "";
        this.projection = "";
    }
}
//# sourceMappingURL=SportDataGatewayQueryInfo.js.map